import ICMWrapper from "@/app/components/icm-wrapper";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import Image, { StaticImageData } from "next/image";
import React from "react";

interface StepsInner {
    img: string | StaticImageData;
    title: string;
    subTitle:  string;
    arrow?: string | StaticImageData;
}

interface HowToComponentProps {
    title: string;
    steps: StepsInner[];
    buttons: btnObj[];
}

interface btnObj {
    label: string;
    variant: string;
    onClick: (event: string) => void;  // Updated to match toggleDownloadApp signature
}

const HowToComponent: React.FC<HowToComponentProps> = ({ title, steps, buttons }) => {
    return (
        <section id="how-to-component" className="bg-muted-blue-300 bg-[url('https://assets.incredmoney.com/images/webp/how-to-invest.webp')] bg-[length:90%] bg-no-repeat py-14 md:bg-[length:35%] md:py-32">
            <h2 id="how-to-title" className="text-center text-4xl font-semibold text-white md:text-7xl">
                {title}
            </h2>
            <ICMWrapper>
                <div id="how-to-steps-container" className="relative flex flex-col justify-between gap-12 py-10 md:flex-row md:gap-20 items-start">
                    {steps.map((step, index) => (
                        <React.Fragment key={index}>
                            <div id={`how-to-step-${index + 1}`} className="flex-1">
                                <div id={`how-to-step-image-container-${index + 1}`} className="mb-7 rounded-2xl bg-muted-blue-200">
                                    <Image id={`how-to-step-image-${index + 1}`} src={step.img} alt={step.title} className="w-full max-h-full" width={0} height={0} />
                                </div>
                                <div id={`how-to-step-text-${index + 1}`} className="text-center">
                                    <h5 id={`how-to-step-title-${index + 1}`} className="text-xl font-semibold leading-[26px] mb-1 md:mb-0 md:leading-loose text-white">
                                        {step.title}
                                    </h5>
                                    <p 
                                        id={`how-to-step-subtitle-${index + 1}`} 
                                        className="leading-[22.4px] tracking-[0.14px] md:leading-relaxed text-white"
                                        dangerouslySetInnerHTML={{ __html: step.subTitle }}
                                    />
                                </div>
                                {step.arrow && (
                                    <Image
                                        id={`how-to-step-arrow-${index + 1}`}
                                        src={step.arrow}
                                        alt={`Step ${index + 1} Arrow`}
                                        className={`hidden md:flex absolute ${index === 0 ? 'md:top-[245px] md:left-[320px]' : index === 1 ? 'md:top-[190px] md:left-[742px]' : ''}`}
                                        width={172}
                                        height={43}
                                    />
                                )}
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <div id="how-to-buttons-container" className="flex flex-col items-center justify-center gap-4 md:flex-row">
                    {buttons.map((btn, index) => (
                        <RegularButton
                            id={`how-to-button-${index + 1}`}
                            key={index}
                            noIcon
                            showRightIcon={false}
                            size={ButtonSize.Large}
                            variant={
                                btn.variant === "primary"
                                    ? ButtonVariant.SecondaryDefault
                                    : ButtonVariant.SecondaryDefault
                            }
                            label={btn.label}
                            className={`w-full max-w-full ${
                                btn.variant === "primary"
                                    ? "bg-white"
                                    : "border-neutralOpacityLight-30 text-white hover:text-black"
                            } md:max-w-fit`}
                            onClick={() => btn.onClick("FD_Book")}
                        />
                    ))}
                </div>
            </ICMWrapper>
        </section>
    );
};

export default HowToComponent;